import { render } from "./PageHeader.vue?vue&type=template&id=7e5455c7&scoped=true&lang=pug"
import script from "./PageHeader.vue?vue&type=script&lang=ts"
export * from "./PageHeader.vue?vue&type=script&lang=ts"

import "./PageHeader.vue?vue&type=style&index=0&id=7e5455c7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7e5455c7"

export default script